import { ActionButtonProps } from "@able/react/dist/ActionButton";
import Column from "@able/react/dist/Column";
import Divider from "@able/react/dist/Divider";
import { MouseEventHandler, PropsWithChildren, RefObject, useId } from "react";
import getFilterActionComponent from "../DataFilters/Data.helpers";
import { DropdownMenuProps } from "../DropdownMenu";
import DynamicAdjustableList from "../DynamicAdjustableList/DynamicAdjustableList";
import FilterByString, { FilterByStringProps } from "../FilterByString";
import { PopoverMultiSelectProps } from "../PopoverMultiselect/PopoverMultiselect";
import { AbleCommonProps } from "../Types";
import './style.scss';

export type DataActionDropdownItemType = & React.HTMLProps<HTMLButtonElement | HTMLAnchorElement> & {
    label: string;
    type?: 'button' | 'a'
};

export type DataActionDropdownProps = Omit<DropdownMenuProps, 'isExpanded' | 'setExpanded' | 'variant'>
    & {
        items: DataActionDropdownItemType[];
        onSelectitem?: (item: DataActionDropdownItemType, event?: any) => void;
    };

export type DataActionType = {
    type: "PopoverMultiSelect" | "ActionButton" | "DropdownMenu",
    props: PopoverMultiSelectProps | ActionButtonProps | DataActionDropdownProps
}

type DataActionsRefs = {
    buttonRef?: RefObject<HTMLButtonElement>,
    inputRef?: RefObject<HTMLInputElement>
}

export type DataActionsProps = AbleCommonProps
    & Pick<FilterByStringProps, 'getQueryText'>
    & PropsWithChildren
    & DataActionsRefs
    & {
        queryText?: string;
        onClickAll?: MouseEventHandler<HTMLElement>;
        actions?: DataActionType[];
        filterByStringProps?: Partial<FilterByStringProps>
    };


const DataActions = (props: DataActionsProps) => {

    const { developmentUrl, queryText, getQueryText, actions = [], onClickAll, filterByStringProps, inputRef, buttonRef } = props;
    const id = useId();
    const customSearchLength = filterByStringProps?.customSearchLength ?? 3;

    return (
        <div className="ted-ui-data-actions">
            <Column bmd={3}>
                <FilterByString
                    id={`ted-ui-${id}-DataAction-FilterByString`}
                    developmentUrl={developmentUrl}
                    placeholderText="Search"
                    hasSearchButton={true}
                    customSearchLength={customSearchLength}
                    {...filterByStringProps}
                    helpText={filterByStringProps?.helpText ?? `Minimum ${customSearchLength} characters to search`}
                    variant="compact"
                    value={queryText ?? ''}
                    getQueryText={getQueryText}
                    elementRef={filterByStringProps?.elementRef ?? inputRef}
                />
            </Column>
            <Column bmd={9}>
                <div className={'ted-ui-actions-spacing'}>
                    <DynamicAdjustableList allBtnRef={buttonRef} className="ted-ui-DataAction-Container" allButtonLabel={"All actions ..."} onClickAllButton={onClickAll}>
                        {actions.map(getFilterActionComponent(developmentUrl as string, 'action'))}
                    </DynamicAdjustableList>
                </div>
                <Divider />
            </Column>
        </div>
    )
};

DataActions.displayName = 'DataActions';

export default DataActions